import React, { useMemo } from "react";
import "./FocusTickerSkeleton.css";
import { createSynchronizedSkeletonStyle } from "../../utils/skeletonMotion";

/*
|----------------------------------------------------------------------------
| Desktop Focus ticker skeleton
|----------------------------------------------------------------------------
|
| The irregular widths intentionally resemble continuing ticker headlines.
| Keep this list static so the skeleton does not change between renders.
|
*/
const BAR_WIDTHS = [
  180,
  520,
  310,
  205,
  430,
  270,
  590,
  160,
  360,
  470,
  195,
  325,
];

const FocusTickerSkeleton = () => {
  const synchronizedMotionStyle = useMemo(
    () => createSynchronizedSkeletonStyle(),
    []
  );

  return (
    <div
      aria-label="در حال بارگذاری اخبار"
      className="focus-ticker-skeleton"
      role="status"
      style={synchronizedMotionStyle}
    >
      <div
        aria-hidden="true"
        className="focus-ticker-skeleton__row"
      >
        {BAR_WIDTHS.map((width, index) => (
          <span
            key={`${width}-${index}`}
            className="focus-ticker-skeleton__bar"
            style={{ "--focus-ticker-bar-width": `${width}px` }}
          />
        ))}
      </div>
    </div>
  );
};

export default FocusTickerSkeleton;
